<template>
  <div class="page">
    <navigation class="nav">活动规则</navigation>
    <div class="container">
      <div class="content">
        <div class="section">
          <div class="title">活动时间：{{ new Date() | formateDate('YYYY年MM月DD日') }}</div>
        </div>
        <div class="section">
          <div class="title">活动对象</div>
          <div class="desc">天美贷平台指定优质用户</div>
        </div>
        <div class="section">
          <div class="title">活动方式</div>
          <div class="desc">1、活动期间，活动用户每天有一次抽奖机会，抽中活动奖项后，当日发起提现申请，即默认使用抽中的福利特权</div>
          <div class="desc">2、活动奖项说明： <br/>
            提现加速卡：提现可享免排队、优先审批放款的特权 <br/>
            专属资金：根据用户资质匹配高通过率的优质资金 <br/>
            临时提额：临时额度仅当日有效，一次性提取有效 <br/>
            50元免息券：提现默认使用，关联借据首笔还款后5个工作日内返现至银行卡 <br/>
            10元现金红包：提现后即可到我的券包提现至银行卡</div>
        </div>
      </div>
      <div class="footer">活动所有解释权归天美贷所有</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActOneRules',
  mounted () {
    // todo: 活动时间取值？
    this.$bus.$emit('ready')
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.page {
 background: linear-gradient( 180deg, #2B66FB 0%, #ACF3F7 45%, #FBE8DB 100%);
  width: 100%;
  min-height: 100vh;
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 40px;
    .content {
      width: 670px;
      height: 1240px;
      border-radius: 30px;
      background-color: white;
      padding: 60px 30px;
      .section {
        margin-bottom: 60px;
        .title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 32px;
          color: #333333;
          line-height: 45px;
        }
        .desc {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #666666;
          line-height: 37px;
        }
      }
    }
    .footer {
      text-align: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #999999;
      line-height: 33px;
      margin-top: 50px;
    }
  }
}
</style>